// extracted by css-extract-rspack-plugin
export default {"container":"_f609443e","icon":"_96f455b2"};